import { AirStatusesModel } from "entities/shared/airCard.types";
import { CoordinateModel } from "entities/shared/shipmentCard.types";
import { AirSearchCardModel } from "entities/AirSearchCard";
import { ValueOf } from "shared/lib/typeCheck.lib";

/**
 * The statuses a saved card may hold. Ocean and air share one store, and the
 * cabinet reads it too, so only this set is understood there - the air
 * widget's own extra statuses (BOOKED, RECEIVED, ARRIVED, ...) would show up
 * as nothing at all in the cabinet's table and filters.
 */
const SAVED_STATUSES: ValueOf<typeof AirStatusesModel>[] = [
  AirStatusesModel.UNKNOWN,
  AirStatusesModel.PLANNED,
  AirStatusesModel.IN_TRANSIT,
  AirStatusesModel.DELIVERED,
  AirStatusesModel.CANCELLED,
];

export const mapAirStatusForSaved = (
  status: ValueOf<typeof AirStatusesModel> | null | undefined
): ValueOf<typeof AirStatusesModel> => {
  if (!status) return AirStatusesModel.UNKNOWN;

  return SAVED_STATUSES.find((known) => known === status) ?? AirStatusesModel.UNKNOWN;
};

export const getFollowCardPin = (data: AirSearchCardModel): CoordinateModel | null => {
  if (!data.hasPin()) {
    return null;
  }

  switch (data.status) {
    case AirStatusesModel.NULL:
    case AirStatusesModel.CANCELLED:
    case AirStatusesModel.BOOKED:
    case AirStatusesModel.RECEIVED:
    case AirStatusesModel.PLANNED:
    case AirStatusesModel.DEPARTED:
    case AirStatusesModel.IN_TRANSIT: {
      return data.polCoordinate;
    }
    case AirStatusesModel.ARRIVED:
    case AirStatusesModel.NOTIFIED:
    case AirStatusesModel.DELIVERED: {
      return data.podCoordinate;
    }
    default:
      return null;
  }
};
